import usePackageViewsTierProgression from 'loyalty/hooks/usePackageViewsTierProgression'
import useUserTierProgress from 'loyalty/hooks/useUserTierProgress'
import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import TierProgressionBanner from './TierProgressionBanner'
import { EmptyArray } from 'lib/array/arrayUtils'
import { OptimizelyExperiments } from 'constants/optimizely'
import useExperiment from 'hooks/Optimizely/useExperiment'

interface Props {
  className?: string
  offer: App.HotelOffer | App.VillaOffer | App.BundleOffer | undefined
  packageViews?: Array<App.OfferPackageOptionView>
  checkoutDate?: string
}

function FlashTierProgressionPanel({ className, offer, packageViews = EmptyArray, checkoutDate }: Props) {
  const {
    showTierProgressionBanner,
    lowestUnlockableTier,
    lowestUnlockableTierName,
    highestUnlockableTier,
    highestUnlockableTierName,
    hasMultipleTierJumps,
    isLoading,
    membershipYearEndDate,
  } = usePackageViewsTierProgression({
    packageViews,
    offer,
    checkoutDate,
    skip: packageViews.length === 0,
  })

  const canActivateTierProgressionExperiment = showTierProgressionBanner && !isLoading
  const { isAnyVariant: isTierProgressionExperimentVariant } = useExperiment(
    OptimizelyExperiments.croTierProgressionOfferPage,
    { canActivate: canActivateTierProgressionExperiment },
  )

  const { creditsNeeded, nightsNeeded } = useUserTierProgress()

  if (!canActivateTierProgressionExperiment || !isTierProgressionExperimentVariant || isLoading || !showTierProgressionBanner) {
    return null
  }

  return (
    <TierProgressionBanner
      className={className}
      lowestUnlockableTier={lowestUnlockableTier}
      lowestUnlockableTierName={lowestUnlockableTierName}
      highestUnlockableTier={highestUnlockableTier}
      highestUnlockableTierName={highestUnlockableTierName}
      hasMultipleTierJumps={hasMultipleTierJumps}
      statusCreditsNeeded={creditsNeeded}
      nightsNeeded={nightsNeeded}
      membershipYearEndDate={membershipYearEndDate}
      checkoutDate={checkoutDate}
    />
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsCurrentRegionUserLoyaltyRegion)
})(FlashTierProgressionPanel)
